import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import { makeStyles } from 'tss-react/mui';

import { LANG } from '../../../services/Config';

import routes from '@/assets/constants/routes-no';

const useStyles = makeStyles()(({ breakpoints }) => ({
  logoContainer: {
    position: 'relative',
    paddingTop: '15%',
    display: 'flex',
    justifyContent: 'center',
    width: '50%',
    [breakpoints.up('sm')]: {
      paddingTop: '10%',
      width: '33.33%',
    },
    [breakpoints.up('md')]: {
      paddingTop: '5%',
      width: '20%',
    },
  },
  logo: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: 'auto',
    maxHeight: 30,
    maxWidth: '60%',
    [breakpoints.up('sm')]: {
      maxHeight: 40,
    },
    [breakpoints.up('md')]: {
      maxWidth: '80%',
    },
  },
  logoBig: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: 'auto',
    maxHeight: 70,
    maxWidth: '60%',
    [breakpoints.up('sm')]: {
      maxHeight: 80,
    },
    [breakpoints.up('md')]: {
      maxWidth: '80%',
    },
  },
}));

interface PartnerBankImageProps {
  item: any;
  variant?: 'unicolored' | 'multicolored';
  isLink?: boolean;
}

const PartnerBankImage = ({
  item,
  variant = 'unicolored',
  isLink = false,
}: PartnerBankImageProps) => {
  const { classes, cx } = useStyles();
  const logoColorVariant = variant === 'unicolored' ? 0 : 1;
  const { appStrings } = LANG;

  return isLink ? (
    <Link
      key={item.key}
      component={RouterLink}
      to={routes.ERROR_PAGE}
      // to={
      //   generatePath(routes.PARTNER_BANK_DETAILS, {
      //     bankKey: item.key,
      //   }) || null
      // }
      className={classes.logoContainer}
      aria-label={`${item.key} ${appStrings.DETAILS_PAGE}`}
    >
      <img
        src={item.src[logoColorVariant]}
        alt={`${item.key} logo`}
        className={cx(
          item && item.key === 'bankNorwegian' ? classes.logoBig : classes.logo,
        )}
        loading="lazy"
      />
    </Link>
  ) : (
    <div key={item.key} className={classes.logoContainer}>
      <img
        src={item.src[logoColorVariant]}
        alt={`${item.key} logo`}
        className={cx(
          item && item.key === 'bankNorwegian' ? classes.logoBig : classes.logo,
        )}
        loading="lazy"
      />
    </div>
  );
};

export default PartnerBankImage;
